import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Menu, X } from "lucide-react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { GITHUB, LINKEDIN } from "./siteInfo";

const navLinks = ["Home", "About", "Skills", "Projects", "Services", "Contact"];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");
  const [onDark, setOnDark] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      // the hero and projects sections are dark, so the nav switches to light text over them
      const dark = ["home", "projects"].some((id) => {
        const el = document.getElementById(id);
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.top <= 50 && r.bottom > 50;
      });
      setOnDark(dark);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // highlight the link of the section currently in view
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-45% 0px -50% 0px" }
    );
    navLinks.forEach((n) => {
      const el = document.getElementById(n.toLowerCase());
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header className={`navbar ${scrolled ? "navbar-scroll" : ""} ${onDark && !menuOpen ? "on-dark" : ""}`}>
      <nav className="navbar-container" aria-label="Main">
        <a href="#home" className="logo">
          Kiran<span>.</span>
        </a>

        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          {navLinks.map((item) => {
            const id = item.toLowerCase();
            return (
              <li key={item}>
                <a
                  href={`#${id}`}
                  className={active === id ? "current" : ""}
                  onClick={() => setMenuOpen(false)}
                >
                  {item}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="nav-right">
          <a
            href={GITHUB}
            target="_blank"
            rel="me noopener noreferrer"
            aria-label="GitHub"
            className="nav-icon"
          >
            <FaGithub />
          </a>
          <a
            href={LINKEDIN}
            target="_blank"
            rel="me noopener noreferrer"
            aria-label="LinkedIn"
            className="nav-icon"
          >
            <FaLinkedin />
          </a>
          <a href="#contact" className="btn btn-primary nav-cta">
            Hire me
          </a>
          <button
            className="menu-icon"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
